import { useContext as t } from "react";
import { PLMapboxInternalMapIdContext as o } from "./index.es20.js";
const a = () => t(o);
export {
  a as usePLMapboxInternalMapId
};
//# sourceMappingURL=index.es22.js.map
